module.exports = {
	"articleTitle1": "Café Habana to relocate to Main Street",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Blue Tractor BBQ & Brewery",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/news/arts-ann-arbor-breweries",
	"articleSnippet1": "Jan 11, 2012 ... Café Habana, which shares an owner with Blue Tractor BBQ & Brewery next door\n, will move to a new building on Main Street in an effort to ...",
	"articleSnippet2": "Sep 14, 2015 ... Later in the week, I headed over to Blue Tractor BBQ & Brewery, which also only \nbrews and sells on the premises. Steve Barnes, formerly ...",
	"foodRecommendations": [
		{
			"text": "One of Ann Arbor's few attempts at BBQ",
			"person": "Ian McKenzie"
		}
	],
	"articleTitle2": "Crafting community: The history of Ann Arbor Breweries ",
	"address": "207 E Washington St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.2806,
		"lng": -83.7469
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/bluetractor.json
// module id = 835
// module chunks = 0